export default "__VITE_ASSET__Cjfi0RSY__"